var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@3c27531c0f955f5422977b634f3899646b07edf3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@3c27531c0f955f5422977b634f3899646b07edf3"};
      